import { Box } from "@mui/material"
import { PageCard, PageCardContent } from "components/card"
import React from "react"

export const EventsKioskHPage = ({ Layout = Box }) => {
  return (
    <Layout aside={<></>}>
      <PageCard>
        <PageCardContent>Events Page</PageCardContent>
      </PageCard>
    </Layout>
  )
}
